/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * GTO Wizard API v4
 * API documentation for GTO Wizard frontend API
 * OpenAPI spec version: 4
 */

export type BetSizeEnum = (typeof BetSizeEnum)[keyof typeof BetSizeEnum]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BetSizeEnum = {
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE',
  OVERBET: 'OVERBET',
} as const
